<template>
  <div class="page_content module_page catalog details">
    <div class="row page-heading">
      <div class="col-7 input module_heading" role="heading" aria-level="1">
        <div class="module_icon ico-catalog"></div>
        <!--<label class="label" for="catalogTitle">Catalog: </label>-->
        <label id="catalogTitle" class="head_txt module_type_name">{{ catalog.title }}</label>
      </div>
      <div class="col-5 float-right px-0">
        <div class="btn-container">
        </div>
      </div>
    </div>
    <div class="column-3">
      <!-- NOTE: ideally the following b-col should be sized to cols-3, but using 9 for testing TOC component -->
      <!-- start TOC -->
      <div class="toc_panel">
        <b-list-group>
          <div class="list-group-item">
            <div class="toc_row table-content-header" style="cursor:pointer;">
              <span class="icon-ic_ToC"></span>
              <span class="header-text ace_sec_hd toc_hd_txt" @click="returnToCatalogClicked" tabindex="0">{{catalog.title}} - Table Of Contents</span>
            </div>
          </div>
          <div class="content-scroll-column">
            <b-list-group-item class="topic-list-item" v-for="year in years" :key="year.uuid">
              <div v-if="year.isCourse" class="toc_row row_1" :id="'nodeRow_' + year.uuid">
                <button class="icon ic-expand_r" :id="'ic_' + year.uuid" v-b-toggle="'tc_' + year.uuid"></button>
                <b-link>
                  <span class="toc_node_ic ico-catalog"></span>
                  <span class="lnk_txt" v-on:click="setSelectedCourse(year)" :title="year.title">{{year.title}}</span>
                </b-link>
              </div>
              <div v-else class="toc_row row_1" :id="'nodeRow_' + year.uuid">
                <button class="icon ic-expand_r" :id="'ic_' + year.uuid" v-b-toggle="'tc_' + year.uuid" v-on:click="switchClass(year.uuid)"></button>
                <b-link>
                  <span class="toc_node_ic ico-catalog"></span>
                  <span class="lnk_txt" v-on:click="expandCollapseTreeNode(year.uuid)" :title="year.title">{{year.title}}</span>
                </b-link>
              </div>
              <!--sub topic -->
              <b-collapse :id="'tc_' + year.uuid">
                <b-list-group v-if="year.semesters">
                  <b-list-group-item class="topic-list-item" v-for="semester in year.semesters" :key="semester.uuid">
                    <div class="toc_row row_2" :id="'nodeRow_' + semester.uuid">
                      <button class="icon ic-expand_r" :id="'ic_' + semester.uuid" v-b-toggle="'tc_' + semester.uuid" v-on:click="switchClass(semester.uuid)"></button>
                      <b-link>
                        <span class="toc_node_ic ico-catalog"></span>
                        <span class="lnk_txt" v-on:click="expandCollapseTreeNode(semester.uuid)" :title="semester.title">{{semester.title}}</span>
                      </b-link>
                    </div>
                    <!-- sub sub topic -->
                    <b-collapse :id="'tc_' + semester.uuid">
                      <b-list-group v-if="semester.courses">
                        <b-list-group-item class="topic-list-item" v-for="course in semester.courses" :key="course.uuid">
                          <div class="toc_row row_3" :id="'tc_' + course.uuid">
                            <b-link @click="setSelectedRow(course)">
                              <span class="toc_node_ic icon-course"></span>
                              <span class="lnk_txt" @click="expandCollapseTreeNode(course.uuid)" :title="course.title">{{course.title}}</span>
                            </b-link>
                          </div>
                        </b-list-group-item>
                      </b-list-group>
                    </b-collapse>
                    <!-- sub sub topic ends-->
                  </b-list-group-item>
                </b-list-group>
              </b-collapse>
              <!--sub topic ends -->
            </b-list-group-item>
          </div>
        </b-list-group>
      </div>
      <!-- END TOC -->
      <!-- NOTE: the following b-col should ideally be sized to cols-9, but using 3 for testing TOC component -->
      <!-- Catalog Information -->
      <b-col v-if="!selectedCourse || !selectedCourse.uuid" class="right-col">
        <b-col class="thumbnail_panel">
          <div v-if="catalog.thumbnailURI" class="thumbnail_container d-flex" tabindex="0">
            <img id="catalogThumbnail" :src="catalog.thumbnailURI">
          </div>
          <div v-else class="thumbnail_container d-flex" tabindex="0">
            <div class="default">
              <div class="thumbnail">
                <div class="thumbnail_icon ico-catalog"></div>
              </div>
            </div>
          </div>
          <div v-if="catalogLibraryName && catalogLibraryName.length > 0" class="content-row">
            <label class="heading" for="catalogOwningLibrary" tabindex="0">Folder</label>
            <div id="catalogOwningLibrary" class="result-value" :title="catalogLibraryName" tabindex="0">{{ catalogLibraryName }}</div>
          </div>
          <div v-if="catalog.division" class="content-row">
            <label class="heading" for="catalogDivision" tabindex="0">Division</label>
            <div id="catalogDivision" class="result-value" :title="catalog.division" tabindex="0">{{ catalog.division }}</div>
          </div>
          <div v-if="catalog.department" class="content-row">
            <label class="heading" for="catalogDepartment" tabindex="0">Department</label>
            <div id="catalogDepartment" class="result-value" :title="catalog.department" tabindex="0">{{ catalog.department }}</div>
          </div>
          <div v-if="catalog.subject" class="content-row">
            <label class="heading" for="catalogSubject" tabindex="0">Subject</label>
            <div id="catalogSubject" class="result-value" :title="catalog.subject" tabindex="0">{{ catalog.subject }}</div>
          </div>
          <div v-if="catalog.level" class="content-row">
            <label class="heading" for="catalogLevel" tabindex="0">Level</label>
            <div id="catalogLevel" class="result-value" :title="catalog.level" tabindex="0">{{ catalog.level }}</div>
          </div>
          <div v-if="catalog.minCredit && catalog.maxCredit" class="content-row">
            <label class="heading" for="catalogCredit" tabindex="0">Credit</label>
            <div id="catalogCredit" class="result-value" tabindex="0">Max - {{ catalog.maxCredit }}, Min - {{ catalog.minCredit }}</div>
          </div>
        </b-col>
        <b-col class="info-col page-section">
          <div v-if="catalog.description" class="page_section_row min-content">
            <div class="heading">
              <label for="catalogDescription" tabindex="0">Catalog Description</label>
            </div>
            <div id="catalogDescription" class="page_content_block">
              <div class="courseDesc">
                <div class="course-desc-content" tabindex="0" v-html="catalog.description"> </div>
              </div>
            </div>
            <a href="javascript:void(0)" class="more-btn more-desc float-right mt-1" @click="showAll" aria-label="read more">more</a>
            <b-modal id="catalogDesc" class="custom_modal course_description" size="lg" centered hide-footer>
              <div slot="modal-header" class="header-section">
                <div class="popup-heading">Catalog Description</div>
                <button class="btn_close" aria-label="close" @click="closeshowAll">
                <span class="ic-close"></span>
                </button>
              </div>
              <div class="catalog-desc-content" tabindex="0" v-html="catalog.description"></div>
            </b-modal>
          </div>
          <!-- skills -->
          <div class="page_section_row" v-if="skills && skills.length > 0">
            <div class="heading"><label for="catalogSkillTags">Skills</label></div>
            <div id="catalogSkillTags" class="page_content_block">
              <div class="tag-section">
                <div class="tag-container">
                  <div class="icon-container" style="width: 20px; float: left;">
                    <span class="icon ic-tag"></span>
                  </div>
                  <div class="tags-row tags_container" style="width: calc(100% - 40px); margin-top: 0px;">
                    <span class="tag" style="width: auto;" v-for="tag in skills" :title="tag.name" :aria-label="tag.name">
                      <span class="tag_name competency_tag ace_sec_txt"> {{ tag.name }} </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- tags -->
          <div class="page_section_row" v-if="tags && tags.length > 0">
            <div class="heading"><label for="catalogTags">Tags</label></div>
            <div id="catalogTags" class="page_content_block">
              <div class="tag-section">
                <div class="tag-container">
                  <div class="icon-container" style="width: 20px; float: left;">
                    <span class="icon ic-tag"></span>
                  </div>
                  <div class="tags-row tags_container" style="width: calc(100% - 40px); margin-top: 0px;">
                    <span class="tag" style="width: auto;" v-for="tag in tags" :title="tag.name" :aria-label="tag.name">
                      <span class="tag_name instructional_tag ace_sec_txt"> {{ tag.name }} </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-col>
      <!-- end Catalog Information -->
      <!-- Course Information -->
      <b-col v-else class="right-col">
        <b-col class="thumbnail_panel">
          <div v-if="selectedCourse.thumbnail" class="thumbnail_container d-flex" tabindex="0">
            <img id="courseThumbnail" :src="selectedCourse.thumbnail">
          </div>
          <div v-else class="thumbnail_container d-flex" tabindex="0">
            <div class="default">
              <div class="thumbnail">
                <div class="thumbnail_icon icon-course"></div>
              </div>
            </div>
          </div>
          <div v-if="selectedCourse.term" class="content-row">
            <label class="heading" for="courseTerm" tabindex="0">Term</label>
            <div id="courseTerm" class="result-value" tabindex="0">{{ selectedCourse.term }}</div>
          </div>
          <div v-if="selectedCourse.num" class="content-row">
            <label class="heading" for="courseSection" tabindex="0">Section #</label>
            <div id="courseSection" class="result-value" tabindex="0">{{ selectedCourse.num }}</div>
          </div>
          <div v-if="selectedCourse.currentSeats && selectedCourse.maxSeats" class="content-row">
            <label class="heading" for="courseEnrollment" tabindex="0">Enrollment</label>
            <div id="courseEnrollment" class="result-value" tabindex="0">{{ selectedCourse.currentSeats }}/{{ selectedCourse.maxSeats }}</div>
          </div>
          <div v-if="selectedCourse.roomInformation" class="content-row">
            <label class="heading" for="courseRoom" tabindex="0">Room Information</label>
            <div id="courseRoom" class="result-value" tabindex="0">{{ selectedCourse.roomInformation }}</div>
          </div>
          <div v-if="selectedCourse.crn" class="content-row">
            <label class="heading" for="courseCRN" tabindex="0">CRN</label>
            <div id="courseCRN" class="result-value" tabindex="0">{{ selectedCourse.crn }}</div>
          </div>
        </b-col>
        <b-col class="info-col page-section">
          <div v-if="selectedCourse.description" class="page_section_row min-content">
            <div class="heading" ><label for="courseDescription">Course Section Description</label></div>
            <div id="courseDescription" class="page_content_block">
              <div class="courseDesc">
                <div class="course-desc-content">
                  {{ selectedCourse.description }}
                </div>
              </div>
            </div>
            <a href="javascript:void(0)" class="more-btn more-desc float-right mt-1" @click="showAll" aria-label="read more">more</a>
            <b-modal id="catalogDesc" class="custom_modal course_description" size="lg" centered hide-footer>
              <div slot="modal-header" class="header-section">
                <div class="popup-heading">Course Description</div>
                <button class="btn_close" aria-label="close" @click="closeshowAll">
                <span class="ic-close"></span>
                </button>
              </div>
              <div class="catalog-desc-content" v-html="selectedCourse.description"></div>
            </b-modal>
          </div>
          <div v-if="selectedCourse.facetedCourseTags && selectedCourse.facetedCourseTags.length > 0" class="page_section_row">
            <div class="heading"><label for="courseTags" tabindex="0">Tags</label></div>
            <div id="courseTags" class="page_content_block">
              <div class="tag-section">
                <div class="tag-container">
                  <div class="icon-container" style="width: 20px; float: left;">
                    <span class="icon ic-tag"></span>
                  </div>
                  <div class="tags-row tags_container" style="width: calc(100% - 40px); margin-top: 0px;">
                    <span class="tag" tabindex="0" v-for="obj in selectedCourse.facetedCourseTags">
                    <span v-for="tag in obj.tagNames" class="tag_name"> {{ tag}} </span>
                    </span>
                    <span class="tag-box ellipsisTags" tabindex="0" @click="showTags" style="display:none;">
                    <span class="fa fa-ellipsis-h"> </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-col>
      <!-- end Course Information -->
    </div>
    <!--
    <div class="modal_container">
      <b-modal id="courseTagsPopup catalogTagsPopup" size="lg" centered :title="'Tags'">
        <div class="tags-section">
          <div class="value">
            <div class="tag-box-list">
              <span class="tags" v-for="tag in catalog.appliedTagMap">
                <span class="tag"> {{ tag.name }} </span>
              </span>
            </div>
          </div>
        </div>
        <div slot="modal-header" class="header-section">
          <div class="head_txt">Tags</div>
          <button type="button" class="btn_close" @click="closeTags">
            <span class="ic-close"></span>
          </button>
        </div>

        <div class="footer-section" slot="modal-footer">
          <b-button type="button" class="btn button-primary mr-3" @click="closeTags"> ok </b-button>
        </div>
        </b-modal>
      </div>
      -->
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'

  export default {
    name: 'catalog-detail',
    props: ['uuid', 'loadDataFromServer'],
    data: () => {
      return {
        tags: [],
        skills: [],
        userId: {},
        selectedRow: undefined,
        selectedCourse: {}
      }
    },
    mounted () {
      this.loadDataForCatalogDetail()
    },

    methods: {
      ...mapActions([
        'loadCatalog',
        'loadLibrariesForUser'
      ]),
      showAll () {
        this.$root.$emit('bv::show::modal', 'catalogDesc')
      },
      closeshowAll () {
        this.$root.$emit('bv::hide::modal', 'catalogDesc')
      },
      showTags () {
        this.$root.$emit('bv::show::modal', 'catalogTagsPopup')
      },

      closeTags () {
        this.$root.$emit('bv::hide::modal', 'catalogTagsPopup')
      },
      goToEditPage () {
        this.$router.push({ name: 'editCatalog', params: { uuid: this.uuid } })
      },
      async loadDataForCatalogDetail () {
        await this.loadCatalog({ uuid: this.uuid, loadDataFromServer: this.loadDataFromServer })
        this.userId = localStorage.getItem('userid')
        this.loadLibrariesForUser(this.userId)
        this.populateSkillsAndTags(this.catalog)
      },
      populateSkillsAndTags (entity) {
        let appliedTagMap = entity.appliedTagMap
        if (appliedTagMap) {
          let tagEntries = Object.entries(appliedTagMap)
          if (tagEntries && tagEntries.length > 0) {
            for (const [key, values] of tagEntries) {
              if (key) {
                values.forEach(value => {
                  this.tags.push(value)
                })
              }
            }
          }
        }
        let careerCompetenciesMap = entity.careerCompetenciesMap
        if (careerCompetenciesMap) {
          let skillEntries = Object.entries(careerCompetenciesMap)
          if (skillEntries && skillEntries.length > 0) {
            for (const [key, values] of skillEntries) {
              if (key) {
                values.forEach(value => {
                  this.skills.push(value)
                })
              }
            }
          } else {
            this.skills = entity.careerCompetenciesList
          }
        } else {
          this.skills = entity.careerCompetenciesList
        }
      },
      expandCollapseTreeNode (entityId) {
        $('#ic_' + entityId).trigger('click')
      },
      setSelectedRow (course) {
        this.selectedCourse = course
        let uuid = course.uuid
        const rowId = 'r_' + uuid
        if ($('.row_3').hasClass('active_row')) {
          if (this.selectedRow !== rowId) {
            $('.row_3').removeClass('active_row')
          }
        }
        this.selectedRow = rowId
      },
      setSelectedCourse (course) {
        this.selectedCourse = course
      },
      switchClass (rowId) {
        var elem = $('#ic_' + rowId)
        if (elem.hasClass('ic-expand_r')) {
          elem.removeClass('ic-expand_r')
          elem.addClass('ic-collapse_r')
        } else {
          elem.removeClass('ic-collapse_r')
          elem.addClass('ic-expand_r')
        }
      },
      returnToCatalogClicked () {
        this.selectedCourse = {}
      }
    },
    computed: {
      ...mapState({
        'catalog': state => state.catalog.catalogObject,
        'learningSpaces': state => state.assessment.learningSpaces,
        'ownerId': state => state.catalog.catalogObject.ownerId,
        'owningLibraryId': state => state.catalog.catalogObject.owningLibraryId
      }),
      'catalogLibraryName': function () {
        let libName = ''
        let owningLibraryId = this.owningLibraryId
        this.learningSpaces.forEach(function (lib) {
          if (owningLibraryId === lib.uuid) {
            libName = lib.displayName
          }
        })
        return libName
      },
      years () {
        let formattedYears = []
        if (!this.catalog || !this.catalog.structure) {
          return formattedYears
        }

        let yearList = JSON.parse(this.catalog.structure)
        if (!yearList || !yearList.length) {
          return formattedYears
        }
        yearList.forEach((year) => {
          if (year.structure) {
            let semesterList = JSON.parse(year.structure)
            let formattedSemesters = []
            semesterList.forEach((semester) => {
              if (semester.structure) {
                let courseList = JSON.parse(semester.structure)
                formattedSemesters.push({uuid: semester.title + '_' + new Date().getMilliseconds(), title: semester.title, courses: courseList})
              }
            })
            formattedYears.push({uuid: year.title + '_' + new Date().getMilliseconds(), title: year.title, semesters: formattedSemesters})
          }
        })
        // the object was returned "flattened" i.e. with just courses and no years/semesters
        if (formattedYears.length === 0) {
          yearList.forEach((course, i) => {
            course.uuid = course.title + '_' + new Date().getMilliseconds() + '_' + i
            course.isCourse = true
            formattedYears.push(course)
          })
        }
        return formattedYears
      }
    }
  }
</script>

<style scoped>
.tag-container {
	max-height: fit-content !important;
}

.label {
  font-size: 20px;
  font-weight: bold;
}

.lnk_txt {
    margin-left: 42px;
    width: 75%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/*NOTE: this ensures the course information panel does not overlay the TOC after course information is clicked*/
.toc_panel {
  position: relative;
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/app/catalog/components/CatalogDetail.vue